import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ColorLens } from "@mui/icons-material";
import { ListItemIcon, MenuItem } from "@mui/material";

import { usePermissionCheck } from "fond/hooks/usePermissionCheck";
import { getCurrentProject } from "fond/project/redux";
import { PermissionLevel, Store } from "fond/types";
import { Actions } from "fond/utils/permissions";

import { trackPageMenuItemClick } from "../helper";

export interface StyleEditorMenuItemProps {
  permissionLevel: PermissionLevel;
  handleClose: () => void;
}

const StyleEditorMenuItem: React.FC<StyleEditorMenuItemProps> = ({ permissionLevel, handleClose }: StyleEditorMenuItemProps) => {
  const versionId = useSelector((state: Store) => state.project.versionId);
  const project = useSelector((state: Store) => getCurrentProject(state.project));
  const navigate = useNavigate();
  const canEdit = usePermissionCheck(Actions.PROJECT_EDIT_STYLES, permissionLevel);

  /**
   * Handles the redirection to the style editor
   */
  const handleClick = () => {
    if (canEdit) {
      handleClose();
      navigate(`/styles/${versionId}`);
      trackPageMenuItemClick("project", "style-editor", project);
    }
  };

  return (
    <MenuItem data-testid="styles-editor-button" onClick={handleClick} disabled={!canEdit}>
      <ListItemIcon>
        <ColorLens />
      </ListItemIcon>
      Style Editor
    </MenuItem>
  );
};

export default StyleEditorMenuItem;
